import { connect } from 'react-redux';
import { closeDrawer } from 'redux-core/dialogs/actions';

const mapDispatchToProps = {
  closeDrawer,
};

export default connect(null, mapDispatchToProps);
